import { ModelHelper } from '../classes/model-helper';

export class Patient {
	firstName: string;
	lastName: string;
	gender: string;
	dateOfBirth: Date;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Patient
	 */
	static map(data: any, item: Patient = new Patient()): Patient {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Patient
	 */
	public map(data: any): Patient {
		ModelHelper.map(data, this, 'firstName');
		ModelHelper.map(data, this, 'lastName');
		ModelHelper.map(data, this, 'gender');
		ModelHelper.map(data, this, 'dateOfBirth', Date);

		return this;
	}
}
